import * as React from "react";
import { Input, InputProps } from "./input";

const DecimalInput = (props: InputProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const [formattedValue, setFormattedValue] = React.useState<string>(
    props.value?.toString?.() || "",
  );

  React.useEffect(() => {
    setFormattedValue(props.value?.toString?.() || "0");
  }, []);

  const handleInputChange = (value: string) => {
    const formattedVal = parseFloat(value.replace(/,/g, "")) || 0;
    const formattedValStr = formattedVal.toLocaleString("en-US", {
      minimumFractionDigits: 0,
    });
    setFormattedValue(formattedValStr);
    // Set the cursor position after updating the input value
    if (inputRef.current) {
      const cursorPosition = inputRef.current.selectionStart;
      inputRef.current.value = formattedValStr;
      inputRef.current.setSelectionRange(cursorPosition, cursorPosition);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "ArrowUp") {
      e.preventDefault();
      incrementValue();
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      decrementValue();
    }
  };

  const incrementValue = () => {
    const currentValue = parseFloat(formattedValue.replace(/,/g, "")) || 0;
    const incrementedValue = currentValue + parseInt((props.step as any) || 1);
    handleInputChange(incrementedValue.toString());
    props.onChange?.(incrementedValue as any);
  };

  const decrementValue = () => {
    const currentValue = parseFloat(formattedValue.replace(/,/g, "")) || 0;
    const decrementedValue = currentValue - parseInt((props.step as any) || 1);
    handleInputChange(decrementedValue.toString());
    props.onChange?.(decrementedValue as any);
  };

  return (
    <Input
      ref={inputRef}
      className={`w-fit text-right`}
      {...props}
      type="text"
      value={formattedValue || ""}
      onChange={(e) => {
        handleInputChange(e.target.value);
        if (props.onChange) {
          e.target.value = e.target.value.replace(/,/g, "");
          props.onChange?.(e);
        }
      }}
      onKeyDown={(e) => {
        handleKeyDown(e);
        props.onKeyDown?.(e);
      }}
    />
  );
};

export default DecimalInput;
